// Tilts its [data-tilt-target] child in 3D toward the pointer, and settles back on leave.
class TiltElement extends HTMLElement {
  #controller = null;

  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const target = this.querySelector('[data-tilt-target]');
    if (!target) return;

    const strength = Number(this.dataset.strength || 22);
    this.#controller = new AbortController();
    const { signal } = this.#controller;

    this.addEventListener(
      'pointermove',
      (event) => {
        const rect = this.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;
        target.style.transform = `rotateY(${x * strength}deg) rotateX(${-y * strength}deg)`;
      },
      { signal },
    );

    this.addEventListener(
      'pointerleave',
      () => {
        target.style.transform = '';
      },
      { signal },
    );
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#controller = null;
  }
}

if (!customElements.get('s-tilt')) {
  customElements.define('s-tilt', TiltElement);
}
